<div
    (click)="promptInstall()"
    (keydown)="promptInstall()"
    (keyup)="promptInstall()"
    *ngIf="!isPwaInstalled"
    class="install-nudge-container d-flex align-items-center justify-content-center"
    id="install-nudge"
>
    <span *ngIf="isIOS" class="open-nudge-button pointer-events-none">
        Add to home screen
    </span>
    <span *ngIf="!isIOS" class="open-nudge-button pointer-events-none"
        >Install on your phone
    </span>
    &nbsp;
    <div *ngIf="isIOS" class="pointer-events-none">
        for quick & easy card sharing
    </div>
    <div *ngIf="!isIOS" class="pointer-events-none">to share cards easily</div>
</div>

<ios-install-drawer
    [showIosInstallDrawer]="isIosPromptDrawerOpen"
    (closeIosInstallDrawer)="isIosPromptDrawerOpen = false"
></ios-install-drawer>
